﻿export default class BufferAnalysisControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, modalWrapper) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.modalWrapper = modalWrapper;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.bufferAnalysisWrapper = 'buffer-analysis-wrapper-' + this.classId + '-' + this.action.Id;
        this.cancelBufferAnalysisId = 'cancel-buffer-analysis-' + this.classId + '-' + this.action.Id;
        this.saveBufferAnalysisId = 'save-buffer-analysis-' + this.classId + '-' + this.action.Id;
        this.bufferAnalysisContainer = 'buffer-analysis-container-' + this.classId + '-' + this.action.Id;
        this.active = false;
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hidePanel();
            } else {
                this._showPanel();
            }
        };
    }

    _hidePanel() {
        $('#' + this.modalWrapper)[0].innerHTML = '';
        $('#' + this.elementId).removeClass('selected');
    }

    _showPanel() {
        $('#' + this.modalWrapper)[0].innerHTML = this._getBufferAnalysisTemplate();
        this._addEvents();
        $('#' + this.elementId).addClass('selected');
    }

    _addEvents() {
        $('#' + this.cancelBufferAnalysisId).on('click', () => {
            this._hidePanel();
        });

        $('#' + this.saveBufferAnalysisId).on('click', () => {
            this._executeBuffer();
        });

        $('#buffer-source').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return this.rootURL + 'Map/GetMapEntities?idMap=' + this.mapControl.mapId;
                        }
                    }
                }
            },
            change: (evt) => {
                let value = evt.sender.dataSource.data().find(row => { return row.Id == evt.sender.value() });
                let url = '';

                if (value.Id < 0) {
                    url = this.rootURL + 'extconn/getextfields?idExtEntity=' + Math.abs(value.Id);
                } else {
                    url = this.rootURL + 'entity/GetFieldsByEntityId?idEntity=' + value.Id;
                }

                $.ajax({
                    type: "GET",
                    url: url,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (value.Id < 0) {
                            result.forEach(item => {
                                item.FieldName = item.Name;
                            });
                        }

                        var dataSource = new kendo.data.DataSource({
                            data: result
                        });

                        dataSource.read();
                        $('#geometry_field').data('kendoComboBox').setDataSource(dataSource);
                        $('#geometry_field').data('kendoComboBox').value(null);
                    }
                });
            }
        });

        $('#geometry_field').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [],
            change: (evt) => {

            }
        });

        $('#buffer-size').kendoNumericTextBox();

        $('#spatial-filter').kendoSwitch({
            messages: {
                checked: 'Da',
                unchecked: 'Nu'
            },
            checked: false
        });

        $('#exclude-original-geom').kendoSwitch({
            messages: {
                checked: 'Da',
                unchecked: 'Nu'
            },
            checked: false
        });
    }

    _executeBuffer() {
        let bufferEntity = $('#buffer-source').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#buffer-source').data('kendoComboBox').value() });
        let fields = $('#geometry_field').data('kendoComboBox').dataSource.data();
        let geomField = $('#geometry_field').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#geometry_field').data('kendoComboBox').value() });
        let data = {
            AnalyseType: 'Complex',
            DataSource: { },
            OutputValues: [],
            LayerName: $('#analysis-name').val() == '' ? (bufferEntity.Name + '-Buffer') : $('#analysis-name').val(),
            PkField: fields.find(x => x.SpecialFieldType == 'PK_FIELD').FieldName,
            GeomField: geomField.FieldName + '_Buffer_' + $('#buffer-size').data('kendoNumericTextBox').value(),
            BboxStrategy: $('#spatial-filter').data('kendoSwitch').check()
        }

        if (bufferEntity.Id < 0) {
            data.DataSource.IdExtEntity = Math.abs(bufferEntity.Id);
        }
        else {
            data.DataSource.IdEntity = bufferEntity.Id;
        }

        data.DataSource.Key = bufferEntity.Name;

        fields.forEach(x => {
            if (x.Id == $('#geometry_field').data('kendoComboBox').value()) {
                if ($('#exclude-original-geom').data('kendoSwitch').check()) {
                    data.OutputValues.push({
                        OutputName: x.FieldName + '_Buffer_' + $('#buffer-size').data('kendoNumericTextBox').value(),
                        Type: 'GeomDifference',
                        Geom1: {
                            Type: 'GeomBuffer',
                            BufferGeometry: {
                                Type: 'Field',
                                DataSourceKey: bufferEntity.Name,
                                IdField: x.Id,
                            },
                            Distance: {
                                Type: 'FixedValue',
                                FixedValue: $('#buffer-size').data('kendoNumericTextBox').value()
                            }
                        },
                        Geom2: {
                            "Type": 'Field',
                            "DataSourceKey": bufferEntity.Name,
                            "IdField": x.Id
                        }
                    });
                } else {
                    data.OutputValues.push({
                        OutputName: x.FieldName + '_Buffer_' + $('#buffer-size').data('kendoNumericTextBox').value(),
                        Index: null,
                        Type: 'GeomBuffer',
                        BufferGeometry: {
                            Type: 'Field',
                            DataSourceKey: bufferEntity.Name,
                            IdField: x.Id,
                        },
                        Distance: {
                            Type: 'FixedValue',
                            FixedValue: $('#buffer-size').data('kendoNumericTextBox').value()
                        }
                    });
                }
            } else {
                data.OutputValues.push({
                    OutputName: x.FieldName,
                    IdField: x.Id,
                    Type: 'Field',
                    DataSourceKey: bufferEntity.Name,
                    Srid: x.Srid
                });
            }
        });

        let analyses = {};

        if (sessionStorage.getItem('xp_analysis') != null) {
            analyses = JSON.parse(sessionStorage.getItem('xp_analysis'));
        }
        let analysesId = this._generateGuid();
        analyses[analysesId] = data;
        sessionStorage.setItem('xp_analysis', JSON.stringify(analyses));
        $event.notify('analysisAdded', { id: analysesId }, this, this.classId);
        this._hidePanel();
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }

    _getBufferAnalysisTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.bufferAnalysisWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0 col-12">
                                <label class="form-label general-settings-title ml-3">Analiza de tip Join</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-3" id="` + this.bufferAnalysisContainer + `">
                                <div class="form-group col-12 mb-1 d-flex">
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Sursa:</label>
                                            <input class="form-control" id="buffer-source">
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Campuri Geometrie:</label>
                                            <input class="form-control" id="geometry_field">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-12 mb-1 d-flex">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Denumire Strat Rezultat:</label>
                                            <input class="form-control" type="text" id="analysis-name">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-12 mb-1 d-flex">
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Marime Buffer:</label>
                                            <input class="form-control" type="text" id="buffer-size">
                                        </div>
                                    </div>
                                    <div class="col-3 mb-3 align-content-center pt-4">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                            <label class="form-label ml-1">Exclude Geometria Initiala</label>
                                            <div id="exclude-original-geom"></div>
                                        </div>
                                    </div>
                                    <div class="col-3 mb-3 align-content-center pt-4">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                            <label class="form-label ml-1">Aplica Filtru Spatial</label>
                                            <div id="spatial-filter"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelBufferAnalysisId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveBufferAnalysisId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanges') + `" type="button">Executa</button>
                        </div>
                    </div>
                </div>`;
    }

    _generateGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}